module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Poptip', {
    staticClass: "search-poptip",
    attrs: {
      "trigger": "focus",
      "placement": "bottom",
      "padding": "24px",
      "disabled": _vm.disabledPoptip
    },
    on: {
      "on-popper-hide": _vm.handleHidePopper
    }
  }, [_c('Input', {
    ref: "search-input",
    staticClass: "search-input",
    attrs: {
      "prefix": _vm.prefix,
      "suffix": _vm.suffix,
      "value": _vm.value,
      "placeholder": "点击搜索视频",
      "size": "large",
      "clearable": ""
    },
    on: {
      "on-change": _vm.handleChangeSearch,
      "on-enter": _vm.handleSearch,
      "on-clear": _vm.handleClearSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search-board",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "history-list"
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('div', {
    staticClass: "list-label"
  }, [_vm._v("最近搜索")]), _vm._v(" "), _c('div', {
    staticClass: "clean-btn"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchHistory && _vm.searchHistory.length),
      expression: "searchHistory && searchHistory.length"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleClearHistory
    }
  }, [_c('trash-2-icon', {
    staticClass: "icon-trash",
    attrs: {
      "size": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v("清空记录")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, [_vm._l((_vm.searchHistory), function(item, index) {
    return [_c('span', {
      key: index,
      staticClass: "history-tag",
      on: {
        "click": function($event) {
          return _vm.handleTagTap(item)
        }
      }
    }, [_vm._v(_vm._s(item))])]
  })], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40607134"}!./~/vue-loader/lib/selector.js?type=template&index=0!./pc/yiqijian-video/components/SearchInput/index.vue
// module id = 51
// module chunks = 1 2 3 4 5